import { render, staticRenderFns } from "./UserActivityItem.vue?vue&type=template&id=e06b015a&scoped=true&"
import script from "./UserActivityItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserActivityItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserActivityItem.vue?vue&type=style&index=0&id=e06b015a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06b015a",
  null
  
)

export default component.exports